import type { AxiosError, AxiosRequestConfig } from 'axios';
import axios from 'axios';

import config from '../../config/config';

export const shouldUseIndexedServerUrls = !config.debug && config.appEnv !== 'dynamic';

function getBaseUrlFromConfig() {
  return shouldUseIndexedServerUrls
    ? `${config.appUrls.p2pServer}/0`
    : config.appUrls.p2pServer;
}

export const createPlayApiClient = ({
  baseUrl,
  handleStatusError,
}: {
  baseUrl?: string;
  handleStatusError?: (status: number, err?: AxiosError<any> | undefined) => void;
}) => {
  const axiosConfig: AxiosRequestConfig = {
    baseURL: baseUrl ?? getBaseUrlFromConfig(),
    withCredentials: true,
  };

  const axiosInstance = axios.create(axiosConfig);

  if (handleStatusError) {
    axiosInstance.interceptors.response.use(
      response => {
        return response;
      },
      error => {
        handleStatusError(error.response?.status, error);
        return Promise.reject(error);
      },
    );
  }

  return axiosInstance;
};

export const playApiClient = createPlayApiClient({});
